/**
 * AnswerAlertCard — the on-the-spot card under an urgent answer (s100, mockup "Orella New Area Questions" v2,
 * approved by Dr. Rami 2026-10-11). Text and tone come from utils/answerAlerts.js; this file only draws.
 * Red = time-sensitive and needs "I understand"; blue = information, no tap.
 */
import { useI18n } from '../../i18n'

export default function AnswerAlertCard({ card, acknowledged, onAcknowledge, disabled }) {
  const { t } = useI18n()
  if (!card) return null
  const red = card.tone === 'red'
  return (
    <div
      role={red ? 'alert' : 'status'}
      className={`mt-1 mb-1 rounded-2xl px-3 py-3 flex gap-2.5 text-[13px] leading-snug ${
        red ? 'bg-red-50 border-[1.5px] border-red-200 text-red-900' : 'bg-[#E9F8FF] border border-[#A7D9FC] text-[#15354F]'
      }`}
    >
      <span
        aria-hidden="true"
        className={`flex-none w-[22px] h-[22px] rounded-full grid place-items-center text-white text-[13px] font-extrabold ${red ? 'bg-red-700' : 'bg-[#46A8F9]'}`}
      >
        {red ? '!' : 'i'}
      </span>
      <div className="min-w-0">
        <p className="font-bold text-[13.5px] mb-0.5">{card.title}</p>
        <p>{card.text}</p>
        {card.ack && (
          <button
            type="button"
            disabled={disabled}
            onClick={onAcknowledge}
            aria-pressed={!!acknowledged}
            className={`mt-2 inline-flex items-center gap-1.5 rounded-full px-4 py-1.5 text-[12.5px] font-bold border-[1.5px] border-red-700 transition-colors ${
              acknowledged ? 'bg-red-700 text-white' : 'bg-white text-red-700 active:bg-red-50'
            }`}
          >
            {acknowledged ? t('describe.alertUnderstood') : t('describe.alertIUnderstand')}
          </button>
        )}
      </div>
    </div>
  )
}
